import React, { useEffect, useRef, useState } from 'react'

import {
  Form,
  Input,
  Row,
  Picker,
  CheckBox,
  Button,
  Grid,
  SelectForm,
  UnidadeGestoraFields
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { UseFormReturn } from 'react-hook-form'
import { SPACING } from 'utils'

export interface IFiltersPesquisa {
  control: UseFormReturn['control']
  reset: UseFormReturn['reset']
  watch: UseFormReturn['watch']
  setValue: UseFormReturn['setValue']
  handleSubmit: (_data) => void
  setPage: (_n: number) => void
  page: number
}

const mobilizacaoOptions = [
  { label: 'Sem Mobilização', value: '0' },
  { label: 'Com Mobilização', value: '1' },
  { label: 'Compartilhado', value: '2' },
  { label: 'Todos', value: '4' }
]

const movInexistenteOptions = [
  { label: 'Cadastradas', value: '0' },
  { label: 'Não Cadastradas', value: '1' },
  { label: 'Todas', value: 'null' }
]

const FiltersPesquisa: React.FC<IFiltersPesquisa> = ({
  control,
  reset,
  handleSubmit,
  watch,
  setPage,
  setValue,
  page
}) => {
  const dataCompetenciaIni = watch('mesAnoInicio')
  const dataCompetenciaFim = watch('mesAnoFim')
  const refDoctorFornecedor = watch('cpf')
  const flContraparte = watch('flContraparte')
  const flAnalista = watch('flAnalista')
  const flTodos = watch('flTodos')

  const [isDateValid, setIsDateValid] = useState<boolean>(false)

  const refUnidGestora = useRef(null)

  useEffect(() => {
    if (flAnalista || flContraparte) {
      setValue('flTodos', false)
    }
  }, [flAnalista, flContraparte])

  useEffect(() => {
    if (flTodos) {
      setValue('flContraparte', false)
      setValue('flAnalista', false)
    }
  }, [flTodos])

  useEffect(() => {
    const quantidadeDatasValidas = [
      dataCompetenciaIni,
      dataCompetenciaFim
    ].filter((value) => value === null).length

    setIsDateValid(quantidadeDatasValidas !== 1)
  }, [dataCompetenciaFim, dataCompetenciaIni])

  return (
    <>
      <Form
        onSubmit={(data) => {
          if (page === 1) { handleSubmit(data) }
          else { setPage(1) }
        }}
      >
        <Grid
          gridCols="1fr 1.5fr 1fr 1fr 1.5fr 2fr"
          gridGap="0.5625rem"
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing20} 0`}
        >
          <Input
            label="Contrato"
            placeholder="Nº"
            control={control}
            formValue="cdContrato"
          />
          <div />
          <Picker
            defaultValue={undefined}
            formValue="mesAnoInicio"
            maxDate={dataCompetenciaFim}
            label="Competência (Início)"
            control={control}
            type="monthAndYear"
          />
          <Picker
            defaultValue={undefined}
            formValue="mesAnoFim"
            minDate={dataCompetenciaIni}
            label="Competência (Fim)"
            control={control}
            type="monthAndYear"
          />
          <div />
          <Input
            label="Fornecedor"
            placeholder="Nome do Fornecedor"
            control={control}
            formValue="nmFornecedor"
          />
        </Grid>
        <Grid
          gridCols="1.5fr 1fr 2fr 3.6fr"
          gridGap="0.5625rem"
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing20} 0`}
        >
          <Input
            control={control}
            placeholder="Nº"
            label="CPF/Passaporte"
            onChange={() =>
              setTimeout(() => {
                return
              }, 100)
            }
            formValue="cpf"
            mask={
              isNaN(refDoctorFornecedor) ? ['NNNNNNNNNNNN'] : ['###.###.###-##']
            }
            maxLength={isNaN(refDoctorFornecedor) ? 13 : 14}
            marginRight={SPACING.spacing20}
          />
          <div />
          <Input
            label="Colaborador"
            placeholder="Nome do Colaborador"
            control={control}
            formValue="nmColaborador"
          />
        </Grid>
        <Grid
          gridCols="8fr 1fr 3fr 3fr 5fr 5fr"
          gridGap="0.625rem"
          margin={`${SPACING.spacing20} 0 ${SPACING.spacing20} 0`}
        >
          <UnidadeGestoraFields
            ref={refUnidGestora}
            gridCols={{
              Diretoria: 5,
              DiretoriaExecutiva: 5,
              Gerencia: 5,
              GerenciaGeral: 5,
              spacing: 1
            }}
            disableFields={['Unidade']}
            control={control}
            formValue="idUnidadeGestora"
          />
          <SelectForm
            marginRight={SPACING.spacing100}
            listOptions={mobilizacaoOptions}
            formValue="flStatusMobilizacao"
            label="Status Mob."
            placeholder="Selecionar status"
            control={control}
            width="150px"
          />
          <SelectForm
            marginRight={SPACING.spacing100}
            listOptions={movInexistenteOptions}
            formValue="flMovInexistente"
            label="Tipos Movimentações."
            placeholder="Tipos Movimentações"
            control={control}
            width="150px"
          />
          <CheckBox control={control} formValue="flTodos" label="Todos" />
          <CheckBox
            control={control}
            formValue="flContraparte"
            label="Validação Contraparte"
          />
          <CheckBox
            control={control}
            formValue="flAnalista"
            label="Validação Analista"
          />

        </Grid>
        <Row
          justifyContent="end"
          marginTop={SPACING.spacing15}
          marginBottom={SPACING.spacing15}
        >
          <Button
            text="Limpar"
            variantButton="outlined"
            onClick={() => {
              reset()
              refUnidGestora?.current?.clearForm()
            }}
            marginRight={SPACING.spacing15}
          />
          <Button
            text="Pesquisar"
            endIcon={<MagnifyingGlassIcon />}
            disabled={!isDateValid}
            type="submit"
          />
        </Row>
      </Form>
    </>
  )
}

export default FiltersPesquisa